import { treaty } from "@elysiajs/eden";
import type { App } from "@upsquad/server";
import { env } from "@/src/common/constants/env";

export const httpClient = treaty<App>(env.SERVER_URL, {
	parseDate: false,
});
